function Error() {
  return (
    <section className="section">
      <div className="container has-text-centered">
        <h2>Error, something has gone wrong! </h2>
      </div>
    </section>
  )
}

export default Error